"use strict";

exports.onRouteUpdate = function (_ref) {
  var _ref$location = _ref.location,
      location = _ref$location === void 0 ? {} : _ref$location;

  // Don't track while developing.
  if (process.env.NODE_ENV === "production" && typeof _czc === "function") {
    window._czc.push(["_trackPageview", "".concat(location.pathname).concat(location.search).concat(location.hash)]);
  }
};